import { useQuery } from "@apollo/client/react";
import { ConnectionStatus, FacilityFeature } from "../api/graphql";
import { GetConnectionFeaturesDocument } from "./GetConnectionFeatures.generated";

/**
 * useConnectionsFeature searches the current visitor's connections for
 * facilities that may have the given feature.
 *
 * It only returns data if the current user is a visitor.
 */
export default function useConnectionsFeature(
  feature: FacilityFeature
): boolean {
  const { data } = useQuery(GetConnectionFeaturesDocument);
  const facilities = (data?.currentVisitor?.connections || [])
    .filter((c) => c.status !== ConnectionStatus.Inactive)
    .map((c) => c.inmate.facility);
  return facilities.some((f) => f.features.includes(feature));
}
